import styled from '@emotion/styled';

export const DetailContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px 42px;

`;

export const HeaderArea = styled.div`
  width: 100%;
  display: flex;
  padding: 32px 42px;
  align-items: center;
  justify-content: space-between;
`;

export const CloseIconWrapper = styled.div`
  display: flex;
`;

export const ViewBoxContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette?.brand?.gray[300]};
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  border-radius: 10px;
  margin-bottom: 48px;
  width: 100%;
`;

export const ViewBoxContent = styled.div`
  display: flex;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.palette?.brand?.gray[300]};
  &:first-of-type {
    border-top: unset;
  }
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.tablet + 'px'}){
      flex-direction: column;
  };
`;

export const ViewBoxItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-left: 1px solid ${({ theme }) => theme.palette?.brand?.gray[300]};
  padding: 12px 24px;
  span {
    display: block;
    &:first-of-type {
      min-width: max-content;
    }
    &:nth-of-type(2) {
      max-width: 70%;
      text-align: right;
    }
  }

  &:first-of-type {
    border-left: unset;
  }
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.tablet + 'px'}){
    max-width: unset !important;
};
`;
